module.exports = __webpack_public_path__ + "img/company.dbec3554.png";